import CommandeLabelsSidebar from "../CommandeLabelsSidebar";
import FiltersSideBar from "../../../layout/FiltersSideBar";

// Filtres de la liste en panneau superposé, sur mobile et tablette.
export function CommandeMobileFiltersLayer({ vm }) {
    const { setFiltersOpen, selectedStatuts, setSelectedStatuts, patientSearch, setPatientSearch, readFilter, setReadFilter, favoriteFilter, setFavoriteFilter, setPage, context } = vm;
    return (
        <div className="commande-mobile-filters-layer">
            <button type="button" className="commande-mobile-layer-backdrop" aria-label="Fermer les filtres" onClick={() => setFiltersOpen(false)} />
            <section className="commande-mobile-filters-panel" role="dialog" aria-modal="true" aria-labelledby="commande-mobile-filters-title">
                <header>
                    <div>
                        <span>COMMANDES</span>
                        <h2 id="commande-mobile-filters-title">Filtres</h2>
                    </div>
                    <button type="button" aria-label="Fermer" onClick={() => setFiltersOpen(false)}>×</button>
                </header>
                <FiltersSideBar
                    selectedStatuts={selectedStatuts}
                    setSelectedStatuts={setSelectedStatuts}
                    patientSearch={patientSearch}
                    setPatientSearch={setPatientSearch}
                    readFilter={readFilter}
                    setReadFilter={setReadFilter}
                    favoriteFilter={favoriteFilter}
                    setFavoriteFilter={setFavoriteFilter}
                    setPage={setPage}
                    showStatutFilter={!!context?.showStatutFilter}
                />
            </section>
        </div>
    );
}

// Libellés de la liste en panneau superposé, sur mobile et tablette.
export function CommandeMobileLabelsLayer({ vm }) {
    const { setLabelsOpen, setPage, page, totalPages, activeLabelKey, selectCustomLabel, clearLabelSelection, currentPharmacyId, commandes } = vm;
    return (
        <div className="commande-mobile-labels-layer">
            <button
                type="button"
                className="commande-mobile-layer-backdrop"
                aria-label="Fermer les libellés"
                onClick={() => setLabelsOpen(false)}
            />
            <div className="commande-mobile-labels-panel" role="dialog" aria-modal="true" aria-label="Libellés des commandes">
                <button type="button" className="commande-mobile-panel-close" aria-label="Fermer" onClick={() => setLabelsOpen(false)}>×</button>
                <CommandeLabelsSidebar
                    activeKey={activeLabelKey}
                    onSelectLabel={label => { selectCustomLabel(label); setLabelsOpen(false); }}
                    onClearLabel={() => { clearLabelSelection(); setLabelsOpen(false); }}
                    pharmacyId={currentPharmacyId}
                    page={page}
                    totalPages={totalPages}
                    setPage={setPage}
                    countsRefreshKey={commandes.map(commande => `${commande.id}:${commande.statut}:${commande.read}:${commande.favorite}`).join("|")}
                />
            </div>
        </div>
    );
}
